import { render, staticRenderFns } from "./ContentAccept.vue?vue&type=template&id=2c535bde&scoped=true&"
import script from "./ContentAccept.vue?vue&type=script&lang=js&"
export * from "./ContentAccept.vue?vue&type=script&lang=js&"
import style0 from "./ContentAccept.vue?vue&type=style&index=0&id=2c535bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c535bde",
  null
  
)

export default component.exports